export const percentToDecimal = (percentString) => {
  // Remove the '%' sign and trim any whitespace
  const sanitizedString = percentString.replace("%", "").trim();

  // Parse the string as a float
  const numericValue = parseFloat(sanitizedString);

  // Check if the conversion was successful
  if (isNaN(numericValue)) {
    throw new Error(`Invalid percentage string: "${percentString}"`);
  }

  // Convert to decimal
  const decimalValue = numericValue / 100;

  return decimalValue;
};

export const isNumber = (value) => {
  return typeof value === "number" && !isNaN(value);
};
